export enum PaymentCategorySystem {
    PREMIUM = 'premium',
    PERFORMANCE = 'performance'
}



// WEBPACK FOOTER //
// ./js/utils/types/payment_categories.ts